module.exports = __webpack_public_path__ + "img/ggA_Tettnang.a2dc8c71.png";